/**
 * 指定した文字列でsplitしつつ整形して返す関数
 * @param text
 * @param separator
 */
export const splitText = (text, separator = ',') => {
    // 数値の場合は文字列型にキャスト
    const value = typeof text === 'number' ? text.toString() : text;
    return (value || '')
        .split(separator)
        .map((v) => v.trim())
        .filter((v) => v);
};
